import React from 'react';

export default function PushTokenBanner({ needAction, busy, onClick }) {
  if (!needAction) return null;
  return (
    <div style={{
      marginTop: 12, padding: 12, borderRadius: 12,
      background: '#fff7ed', border: '1px solid #fed7aa',
      color: '#7c2d12'
    }}>
      <div style={{ marginBottom: 8, fontWeight: 700 }}>通知の許可が必要です</div>
      <div style={{ fontSize: 14, lineHeight: 1.5, marginBottom: 8 }}>
        「受付番号の通知」を受け取るには、通知を許可してください。
      </div>
      <button
        onClick={onClick}
        disabled={busy}
        className="line-primary-btn"
        style={{ padding: '10px 16px' }}
      >
        {busy ? '設定を開いています…' : '通知を許可して登録'}
      </button>
    </div>
  );
}